export default "__VITE_ASSET__ByTdtnMS__"